import { apiClient, buildQueryString } from '@/services/utils';

export default {
  get(capsuleId, withLayerProducts) {
    let queryString

    if (withLayerProducts !== null || withLayerProducts !== undefined) {
      queryString = buildQueryString({ withLayerProducts: withLayerProducts })
    }

    return apiClient.get(`/capsules/${capsuleId}${queryString}`);
  },

  getAll(params) {
    const queryString = buildQueryString(params)

    return apiClient.get(`/capsules${queryString}`);
  },

  create(title, occasion, notes, link) {
    const params = {
      capsule: {
        title: title,
        occasion: occasion,
        notes: notes,
        link: link
      }
    }

    return apiClient.post(`/capsules/`, params)
  },

  update(capsuleId, title, occasion, notes, link) {
    const params = {
      capsule: {
        title: title,
        occasion: occasion,
        notes: notes,
        link: link
      }
    }

    return apiClient.put(`/capsules/${capsuleId}`, params)
  },

  destroy(capsuleId) {
    return apiClient.delete(`/capsules/${capsuleId}/layer_products/${layerProductId}`);
  }
}



// WEBPACK FOOTER //
// ./src/services/api/CapsuleService.js